import Vue from "vue";
import Router from "vue-router";

import store from "./store"

Vue.use(Router);

const router = new Router({
  routes: [{
    path: '/',
    name: 'loginController',
    component: resolve => require(['@/views/login.vue'], resolve),
    meta: {
      title: 'login'
    }
  }, {
    path: '/version',
    name: 'versionController',
    component: resolve => require(['@/views/version.vue'], resolve),
    meta: {
      title: 'Version'
    }
  },
  {
    path: "/main",
    name: "homeController",
    component: () =>
      import("./views/Home.vue"),
    children: [
      {
        path: "homePage",
        component: resolve => require(["@/views/homePage.vue"], resolve),
        meta: {
          title: 'home',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' }
          ]
        },
      },
      {
        path: "userList",
        component: resolve => require(["@/views/userList.vue"], resolve),
        meta: {
          title: 'userList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/userList', text: 'User List' }
          ]
        },
      },
      {
        path: "userDetail",
        component: resolve => require(["@/views/userDetail.vue"], resolve),
        meta: {
          title: 'userDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/userList', text: 'User List' },
            { to: '/main/userDetail', text: 'userDetail' }
          ]
        },
      },
      {
        path: "roleList",
        component: resolve => require(["@/views/roleList.vue"], resolve),
        meta: {
          title: 'roleList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/roleList', text: 'Role List' }
          ]
        },
      },
      {
        path: "roleDetail",
        component: resolve => require(["@/views/roleDetail.vue"], resolve),
        meta: {
          title: 'roleDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/roleList', text: 'Role List' },
            { to: '/main/roleDetail', text: 'roleDetail' }
          ]
        },
      },
      {
        path: "eventGroupList",
        component: resolve => require(["@/views/eventGroupList.vue"], resolve),
        meta: {
          title: 'eventGroupList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventGroupList', text: 'Event Group List' }
          ]
        },
      },
      {
        path: "eventGroupDetail",
        component: resolve => require(["@/views/eventGroupDetail.vue"], resolve),
        meta: {
          title: 'eventGroupDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventGroupList', text: 'Event Group List' },
            { to: '/main/eventGroupDetail', text: 'Event Group Detail' }
          ]
        },
      },
      {
        path: "eventGroupDetailHighLight",
        component: resolve => require(["@/views/eventGroupDetail.vue"], resolve),
        meta: {
          title: 'eventGroupDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/highlights', text: 'Highlights' },
            { to: '/main/eventGroupDetail', text: 'Event Group Detail' }
          ]
        },
      },
      {
        path: "tagList",
        component: resolve => require(["@/views/tagList.vue"], resolve),
        meta: {
          title: 'tagList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/tagList', text: 'Tag List' }
          ]
        },
      },
      {
        path: "tagDetail",
        component: resolve => require(["@/views/tagDetail.vue"], resolve),
        meta: {
          title: 'tagDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/tagList', text: 'Tag List' },
            { to: '/main/tagDetail', text: 'Tag Detail' }
          ]
        },
      },
      {
        path: "highlights",
        component: resolve => require(["@/views/highlights.vue"], resolve),
        meta: {
          title: 'highlights',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/highlights', text: 'Highlights' }
          ]
        },
      },
      {
        path: "eventList",
        component: resolve => require(["@/views/eventList.vue"], resolve),
        meta: {
          title: 'eventList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventList', text: 'Event List' }
          ]
        },
      },
      {
        path: "eventDetail",
        component: resolve => require(["@/views/eventDetail.vue"], resolve),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventList', text: 'Event List' },
            { to: '/main/eventDetail', text: 'Event Detail' }
          ]
        },
      },
      {
        path: "eventDetailHighLight",
        component: resolve => require(["@/views/eventDetail.vue"], resolve),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/highlights', text: 'Highlights' },
            { to: '/main/eventDetail', text: 'Event Detail' }
          ]
        },
      },
      {
        path: "hotTags",
        component: resolve => require(["@/views/hotTags.vue"], resolve),
        meta: {
          title: 'Hot Tags',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/hotTags', text: 'Hot Tags' }
          ]
        },
      },
      {
        path: "hotEditorials",
        component: resolve => require(["@/views/hotEditorials.vue"], resolve),
        meta: {
          title: 'Hot Editorials',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/hotEditorials', text: 'Hot Editorials' }
          ]
        },
      },
      {
        path: "hotEvents",
        component: resolve => require(["@/views/hotEvents.vue"], resolve),
        meta: {
          title: 'Hot Events',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/hotEvents', text: 'Hot Events' }
          ]
        },
      },
      {
        path: "keyVisualList",
        component: resolve => require(["@/views/keyVisualList.vue"], resolve),
        meta: {
          title: 'Key Visual',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/keyVisualList', text: 'Key Visual' }
          ]
        },
      },
      {
        path: "keyVisualDetail",
        component: resolve => require(["@/views/keyVisualDetail.vue"], resolve),
        meta: {
          title: 'Key Visual Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/keyVisualList', text: 'Key Visual' },
            { to: '/main/keyVisualDetail', text: 'Key Visual Detail' }
          ]
        },
      },
      {
        path: "landingPage",
        component: resolve => require(["@/views/landingPage.vue"], resolve),
        meta: {
          title: 'Landing Page Management',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/landingPage', text: 'Landing Page Management' }
          ]
        },
      },
      {
        path: "editorialList",
        component: resolve => require(["@/views/editorialList.vue"], resolve),
        meta: {
          title: 'editorialList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/editorialList', text: 'editorial List' }
          ]
        },
      },
      {
        path: "editorialDetail",
        component: resolve => require(["@/views/editorialDetail.vue"], resolve),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/editorialList', text: 'editorial List' },
            { to: '/main/editorialDetail', text: 'editorial Detail' }
          ]
        },
      },
      {
        path: "dailyRecommendation",
        component: resolve => require(["@/views/dailyRecommendation.vue"], resolve),
        meta: {
          title: 'Daily Recommendation',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/dailyRecommendation', text: 'Daily Recommendation' }
          ]
        },
      },
      {
        path: "shopDescription",
        component: resolve => require(["@/views/shopDescription.vue"], resolve),
        meta: {
          title: 'Shop Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/shopDescription', text: 'Shop Description' }
          ]
        },
      },
      {
        path: "diningDescription",
        component: resolve => require(["@/views/diningDescription.vue"], resolve),
        meta: {
          title: 'Dining Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/diningDescription', text: 'Dining Description' }
          ]
        },
      },
      {
        path: "amenitiesDescription",
        component: resolve => require(["@/views/amenitiesDescription.vue"], resolve),
        meta: {
          title: 'Amenities Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/amenitiesDescription', text: 'Amenities Description' }
          ]
        },
      },
      {
        path: "transportationDescription",
        component: resolve => require(["@/views/transportationDescription.vue"], resolve),
        meta: {
          title: 'Transportation Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/transportationDescription', text: 'Transportation Description' }
          ]
        },
      },
      {
        path: "accessibilityStatement",
        component: resolve => require(["@/views/accessibilityStatement.vue"], resolve),
        meta: {
          title: 'Accessibility Statement',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/accessibilityStatement', text: 'Accessibility Statement' }
          ]
        },
      },
      {
        path: "accessibilityAppUsages",
        component: resolve => require(["@/views/accessibilityAppUsages.vue"], resolve),
        meta: {
          title: 'Accessibility App Usages',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/accessibilityAppUsages', text: 'Accessibility App Usages' }
          ]
        },
      },
      {
        path: "faq",
        component: resolve => require(["@/views/faq.vue"], resolve),
        meta: {
          title: 'FAQ',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/faq', text: 'FAQ' }
          ]
        },
      },
      {
        path: "aboutUs",
        component: resolve => require(["@/views/aboutUs.vue"], resolve),
        meta: {
          title: 'About us',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/aboutUs', text: 'About us' }
          ]
        },
      },
      {
        path: "termsAndConditions",
        component: resolve => require(["@/views/termsAndConditions.vue"], resolve),
        meta: {
          title: 'Terms & Conditions',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/termsAndConditions', text: 'Terms & Conditions' }
          ]
        },
      },
      {
        path: "socialMediaList",
        component: resolve => require(["@/views/socialMediaList.vue"], resolve),
        meta: {
          title: 'Social Media List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/socialMediaList', text: 'Social Media List' }
          ]
        },
      },
      {
        path: "socialMediaDetail",
        component: resolve => require(["@/views/socialMediaDetail.vue"], resolve),
        meta: {
          title: 'Social Media Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/socialMediaList', text: 'Social Media List' },
            { to: '/main/socialMediaDetail', text: 'Social Media Detail' }
          ]
        },
      },
      {
        path: "specialAnnouncement",
        component: resolve => require(["@/views/specialAnnouncement.vue"], resolve),
        meta: {
          title: 'Special Announcement',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/specialAnnouncement', text: 'Special Announcement' }
          ]
        },
      },
      {
        path: "specialAnnouncementDetail",
        component: resolve => require(["@/views/specialAnnouncementDetail.vue"], resolve),
        meta: {
          title: 'Special Announcement Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/specialAnnouncement', text: 'Special Announcement' },
            { to: '/main/specialAnnouncementDetail', text: 'Special Announcement Detail' }
          ]
        },
      },
      {
        path: "parkingDescription",
        component: resolve => require(["@/views/parkingDescription.vue"], resolve),
        meta: {
          title: 'Parking Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/parkingDescription', text: 'Parking Description' }
          ]
        },
      },
      {
        path: "freespaceDescription",
        component: resolve => require(["@/views/freespaceDescription.vue"], resolve),
        meta: {
          title: 'Freespace Long Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/freespaceDescription', text: 'Freespace Long Description' }
          ]
        },
      },
      {
        path: "xiquCentreDescription",
        component: resolve => require(["@/views/xiquCentreDescription.vue"], resolve),
        meta: {
          title: 'Xiqu Centre Long Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/xiquCentreDescription', text: 'Xiqu Centre Long Description' }
          ]
        },
      },
      {
        path: "artParkDescription",
        component: resolve => require(["@/views/artParkDescription.vue"], resolve),
        meta: {
          title: 'Art Park Long Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/artParkDescription', text: 'Art Park Long Description' }
          ]
        },
      },
      {
        path: "mPavilionDescription",
        component: resolve => require(["@/views/mPavilionDescription.vue"], resolve),
        meta: {
          title: 'Arts Pavilion Long Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/mPavilionDescription', text: 'Arts Pavilion Long Description' }
          ]
        },
      },
      {
        path: "mLongDescription",
        component: resolve => require(["@/views/mLongDescription.vue"], resolve),
        meta: {
          title: 'M+ Long Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/mLongDescription', text: 'M+ Long Description' }
          ]
        },
      },
      {
        path: "umbrellaSharingService",
        component: resolve => require(["@/views/umbrellaSharingService.vue"], resolve),
        meta: {
          title: 'Umbrella Sharing Service',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/umbrellaSharingService', text: 'Umbrella Sharing Service' }
          ]
        },
      },
      {
        path: "waterFountainService",
        component: resolve => require(["@/views/waterFountainService.vue"], resolve),
        meta: {
          title: 'Water Fountain Service',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/waterFountainService', text: 'Water Fountain Service' }
          ]
        },
      },
      {
        path: "transitAnnouncement",
        component: resolve => require(["@/views/transitAnnouncement.vue"], resolve),
        meta: {
          title: 'Transit Announcement',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/transitAnnouncement', text: 'Transit Announcement' }
          ]
        },
      },
      {
        path: "promotionList",
        component: resolve => require(["@/views/promotionList.vue"], resolve),
        meta: {
          title: 'Promotion List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/promotionList', text: 'Promotion List' }
          ]
        },
      },
      {
        path: "promotionDetail",
        component: resolve => require(["@/views/promotionDetail.vue"], resolve),
        meta: {
          title: 'Promotion Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/promotionList', text: 'Promotion List' },
            { to: '/main/promotionDetail', text: 'Promotion Detail' }
          ]
        },
      },
      {
        path: "entryBanner",
        component: resolve => require(["@/views/entryBanner.vue"], resolve),
        meta: {
          title: 'Entry Banner',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/entryBanner', text: 'Entry Banner' }
          ]
        },
      },
      {
        path: "deactivatedAccount",
        component: resolve => require(["@/views/accountDeletion.vue"], resolve),
        meta: {
          title: 'Deactivated Account Management',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/deactivatedAccount', text: 'Deactivated Account Management' }
          ]
        },
      },
      {
        path: "poiUpload",
        component: resolve => require(["@/views/poiUpload.vue"], resolve),
        meta: {
          title: 'Poi Upload',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/poiUpload', text: 'Poi Upload' }
          ]
        },
      },
      {
        path: "palaceLongDescription",
        component: resolve => require(["@/views/palaceLongDescription.vue"], resolve),
        meta: {
          title: 'Hong Kong Palace Museum Long Description',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/palaceLongDescription', text: 'Hong Kong Palace Museum Long Description' }
          ]
        },
      },
      {
        path: "membershipManagement",
        component: resolve => require(["@/views/membershipList.vue"], resolve),
        meta: {
          title: 'Membership List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/membershipManagement', text: 'Membership List' }
          ]
        },
      },
      {
        path: "membershipDetail",
        component: resolve => require(["@/views/membershipDetail.vue"], resolve),
        meta: {
          title: 'Membership Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/membershipManagement', text: 'Membership List' },
            { to: '/main/membershipDetail', text: 'Membership Detail' }
          ]
        },
      },
      {
        path: "membershipEvent",
        component: resolve => require(["@/views/membershipEvent.vue"], resolve),
        meta: {
          title: 'Membership Event',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/membershipManagement', text: 'Membership List' },
            { to: '/main/membershipEvent', text: 'Membership Event' }
          ]
        },
      },
      {
        path: "memberPrivilege",
        component: resolve => require(["@/views/memberPrivilegeList.vue"], resolve),
        meta: {
          title: 'Member Privilege List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/memberPrivilege', text: 'Member Privilege List' }
          ]
        },
      },
      {
        path: "memberPrivilegeDetail",
        component: resolve => require(["@/views/memberPrivilegeDetail.vue"], resolve),
        meta: {
          title: 'Member Privilege Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/memberPrivilege', text: 'Member Privilege List' },
            { to: '/main/memberPrivilegeDetail', text: 'Member Privilege Detail' }
          ]
        },
      },
      {
        path: "backgroundTopIcon",
        component: resolve => require(["@/views/backgroundTopIcon.vue"], resolve),
        meta: {
          title: 'Background at the top icon',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/backgroundTopIcon', text: 'Background at the top icon' }
          ]
        },
      },
      {
        path: "mywestkPrivilege",
        component: resolve => require(["@/views/mywestkPrivilege.vue"], resolve),
        meta: {
          title: 'MyWestK Privilege',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/mywestkPrivilege', text: 'MyWestK Privilege' }
          ]
        },
      },
      {
        path: "MMemberEvent",
        component: resolve => require(["@/views/MMemberEvent.vue"], resolve),
        meta: {
          title: 'M+ Member Event',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/MMemberEvent', text: 'M+ Member Event' }
          ]
        },
      },
      {
        path: "MMemberEventDetail",
        component: resolve => require(["@/views/eventDetail.vue"], resolve),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/MMemberEvent', text: 'M+ Member Event' },
            { to: '/main/eventDetail', text: 'Event Detail' }
          ]
        },
      },
      {
        path: "HKPMMemberEvent",
        component: resolve => require(["@/views/HKPMMemberEvent.vue"], resolve),
        meta: {
          title: 'HKPM Member Event',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/HKPMMemberEvent', text: 'HKPM Member Event' }
          ]
        },
      },
      {
        path: "HKPMMemberEventDetail",
        component: resolve => require(["@/views/eventDetail.vue"], resolve),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/HKPMMemberEvent', text: 'HKPM Member Event' },
            { to: '/main/eventDetail', text: 'Event Detail' }
          ]
        },
      },
      {
        path: "MyWestKMemberEvent",
        component: resolve => require(["@/views/MyWestKMemberEvent.vue"], resolve),
        meta: {
          title: 'MyWestK Member Event',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/MyWestKMemberEvent', text: 'MyWestK Member Event' }
          ]
        },
      },
      {
        path: "MyWestKMemberEventDetail",
        component: resolve => require(["@/views/eventDetail.vue"], resolve),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/MyWestKMemberEvent', text: 'MyWestK Member Event' },
            { to: '/main/eventDetail', text: 'Event Detail' }
          ]
        },
      },
      {
        path: "MMemberEditorial",
        component: resolve => require(["@/views/MMemberEditorial.vue"], resolve),
        meta: {
          title: 'M+ Member Editorial',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/MMemberEditorial', text: 'M+ Member Editorial' }
          ]
        },
      },
      {
        path: "MMemberEditorialDetail",
        component: resolve => require(["@/views/editorialDetail.vue"], resolve),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/MMemberEditorial', text: 'M+ Member Editorial' },
            { to: '/main/editorialDetail', text: 'editorial Detail' }
          ]
        },
      },
      {
        path: "HKPMMemberEditorial",
        component: resolve => require(["@/views/HKPMMemberEditorial.vue"], resolve),
        meta: {
          title: 'HKPM Member Editorial',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/HKPMMemberEditorial', text: 'HKPM Member Editorial' }
          ]
        },
      },
      {
        path: "HKPMMemberEditorialDetail",
        component: resolve => require(["@/views/editorialDetail.vue"], resolve),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/HKPMMemberEditorial', text: 'HKPM Member Editorial' },
            { to: '/main/editorialDetail', text: 'editorial Detail' }
          ]
        },
      },
      {
        path: "MyWestKMemberEditorial",
        component: resolve => require(["@/views/MyWestKMemberEditorial.vue"], resolve),
        meta: {
          title: 'MyWestK Member Editorial',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/MyWestKMemberEditorial', text: 'MyWestK Member Editorial' }
          ]
        },
      },
      {
        path: "MyWestKMemberEditorialDetail",
        component: resolve => require(["@/views/editorialDetail.vue"], resolve),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/MyWestKMemberEditorialDetail', text: 'MyWestK Member Editorial' },
            { to: '/main/editorialDetail', text: 'editorial Detail' }
          ]
        },
      },
    ]
  },
  ],
})


export default router
